import Frame from "components/shared/Frame";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "components/shared/Button";
import AppInput from "components/shared/AppInput";

import { IStep } from "types";

import RegistrationStep from "components/shared/RegistrationStep";
import { USER_ROLES } from "utils/UIProvider";

import OtpStep from "../students/components/otp.screen";
import SuccessPage from "components/shared/SuccessPage";
import { signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";

import { auth } from "services/firebase.config";
import { toast } from "react-toastify";
import axios from "axios";
import { api } from "../../../constants";

const ChildHasAccountYes: React.FC<IStep> = ({ onNext, onBack, step }) => {
  const [touched, setTouched] = useState<boolean>(false);

  const [phone, setPhone] = useState<string>("");
  const [countryCode, setCountryCode] = useState<string>("+91");
  const [error, setError] = useState({ phone: "" });
  const [disbale, setDisable] = useState(false);
  function onCaptchVerify() {
    if (
      !(window as any).recaptchaVerifier ||
      (window as any)?.recaptchaVerifier?.destroyed
    ) {
      try {
        (window as any).recaptchaVerifier = new RecaptchaVerifier(
          auth,
          "recaptcha-container",
          {
            size: "invisible",
            callback: (response: any) => {},
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    return () => {
      try {
        if ((window as any).recaptchaVerifier) {
          (window as any).recaptchaVerifier.clear();
        }
      } catch (error) {}
    };
  }, []);

  async function onSignup() {
    setDisable(true);
    axios
      .post(api, {
        cmd: "ModHandle.getStudents",
        phone_number: countryCode + phone,
      })
      .then((results) => {
        if (results?.data?.error) {
          setDisable(false);
          toast.error(
            "phone number is not associated with any student account"
          );
        } else {
          onCaptchVerify();
          const appVerifier = (window as any).recaptchaVerifier;
          const formatPh = countryCode + phone;

          signInWithPhoneNumber(auth, formatPh, appVerifier)
            .then((confirmationResult) => {
              (window as any).confirmationResult = confirmationResult;
              toast.success("OTP sent to your number");
              onNext(countryCode + phone);
              setDisable(false);
            })
            .catch((error) => {
              if (error.code === "auth/invalid-phone-number") {
                return;
              }
              toast.error(error.message);
              setDisable(false);
            });
        }
      })
      .catch(({ response }) => {
        toast.error(response.data.error);
        setDisable(false);
      });
  }

  const handlePhoneChange: React.FormEventHandler<HTMLInputElement> = (e) => {
    if (!touched) setTouched(true);
    const text = e.currentTarget.value;
    setPhone(text);

    if (text === "" || isValidPhoneNumber(text)) setError({ phone: "" });
    else setError({ ...error, phone: "Enter valid phone number" });
  };

  return (
    <Frame
      step={step}
      title="Connecting Your Child’s Account"
      onBackButtonClick={onBack}
    >
      <div>
        <h2 className="mb-5">
          Enter the phone number to verify your child’s account.
        </h2>
        <div id="recaptcha-container"></div>
        <div className="mt-3 d-flex">
          <select
            className="hl-input"
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
          >
            <option value="+1">US (+1)</option>
            <option value="+91">IN (+91)</option>
            <option value="+92">PK (+92)</option>
          </select>
          <AppInput
            value={phone}
            placeholder="Enter Phone Number"
            onChange={handlePhoneChange}
            onBlur={() => setTouched(true)}
          />
        </div>
        {touched && error.phone && (
          <div className="error">
            <p>{error.phone}</p>
          </div>
        )}
        <div className="flex flex-row justify-center">
          <Button
            disabled={disbale}
            style={{ marginTop: 40 }}
            value="Submit"
            onClick={onSignup}
          />
        </div>
      </div>
    </Frame>
  );
};

// You can replace isValidPhoneNumber with your actual phone number validation logic
export const isValidPhoneNumber = (phoneNumber: string) => {
  // Example validation logic
  return /^\d{10}$/.test(phoneNumber); // Checks if phone number has exactly 10 digits
};

export const ParentRegisteration = () => {
  const [currentPath, setCurrentPath] = useState("childHasAccountYes");

  const [state, setState] = useState<any>({});
  const navigate = useNavigate();

  return (
    <div>
      {currentPath === "childHasAccountYes" && (
        <ChildHasAccountYes
          onBack={() => {
            navigate("/");
          }}
          onNext={(val: string) => {
            setState({ phone_number: val });
            setCurrentPath("otpVerification");
          }}
        />
      )}

      {currentPath === "otpVerification" && (
        <OtpStep
          parent={true}
          onBack={() => setCurrentPath("childHasAccountYes")}
          onNext={() => setCurrentPath("registerAccount")}
        />
      )}

      {currentPath === "registerAccount" && (
        <RegistrationStep
          value={{
            data: state,
            role: USER_ROLES.PARENT,
            name: "Parent",
          }}
          onBack={() => setCurrentPath("childHasAccountYes")}
          onNext={() => {
            setCurrentPath("success");
          }}
        />
      )}
      {currentPath === "success" && (
        <SuccessPage value="Go to parent dashboard" />
      )}
    </div>
  );
};
